import { render, staticRenderFns } from "./publicityList.vue?vue&type=template&id=28ebf967&scoped=true"
import script from "./publicityList.vue?vue&type=script&lang=js"
export * from "./publicityList.vue?vue&type=script&lang=js"
import style0 from "./publicityList.vue?vue&type=style&index=0&id=28ebf967&prod&lang=scss"
import style1 from "./publicityList.vue?vue&type=style&index=1&id=28ebf967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ebf967",
  null
  
)

export default component.exports